// const domain = 'http://api.localhost:8082';
const domain = 'https://api.x4digital.com';




export default domain
export const main_domain = 'https://x4digital.com';




// WEBPACK FOOTER //
// ./src/assets/js/config.js